
import determineStage from "@/utils/DetermineStage";

const LLatestActualDate = (initiative) => {
  if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
    return null;
  }
  const l1Entry = initiative.timeline.find(
    (entry) => entry.stage === `${determineStage(initiative)}`
  );
  if (!new Date(l1Entry.date.actual)) {
    return null;
  }
  return new Date(l1Entry.date.actual);
};

export default LLatestActualDate;
